// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.font-size-20[data-v-36a9e3d5] {\n  font-size: 20px;\n}\n.controls-disabled[data-v-36a9e3d5] {\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
